import type { CurrentUser, UserTenant } from "../hooks/useAuthRestApi";

/**
 * テナントロール型（バックエンドのTenantRole enumと同期）
 * @see backend/services/ses-search-api/src/ses_search_api/types/enums.py
 */
export type TenantRole = "owner" | "admin" | "member";

/**
 * テナントロール定数
 */
export const TENANT_ROLES = {
  OWNER: "owner",
  ADMIN: "admin",
  MEMBER: "member",
} as const satisfies Record<Uppercase<TenantRole>, TenantRole>;

/**
 * 管理者ロール（owner/admin）
 */
const ADMIN_ROLES: readonly TenantRole[] = [
  TENANT_ROLES.OWNER,
  TENANT_ROLES.ADMIN,
];

/**
 * ユーザーがテナント管理者（owner/admin）かどうかを判定
 * @param {CurrentUser | null} user - 現在のユーザー情報
 * @return {boolean} テナント管理者の場合true
 */
export const isTenantAdmin = (user: CurrentUser | null): boolean => {
  if (!user?.tenants || user.tenants.length === 0) {
    return false;
  }
  // 最初のテナントのロールをチェック（複数テナント対応時は変更が必要）
  const tenant = user.tenants[0];
  return ADMIN_ROLES.includes(tenant.role as TenantRole);
};

/**
 * ユーザーの現在のテナントを取得
 * @param {CurrentUser | null} user - 現在のユーザー情報
 * @return {UserTenant | null} テナント情報
 */
export const getCurrentTenant = (
  user: CurrentUser | null,
): UserTenant | null => {
  if (!user?.tenants || user.tenants.length === 0) {
    return null;
  }
  return user.tenants[0];
};
